import { Inject, Injectable, PLATFORM_ID } from '@angular/core';

import * as fromRoot from '@app/reducers';
import { Store } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { concatMap, first } from 'rxjs/operators';
import { RedirectionService } from '../services/redirection.service';
import { AccountActions } from '../actions';
import { isPlatformServer } from '@angular/common';


@Injectable({
  providedIn: 'root'
})
export class CanAccessAdministrationGuard  {

  constructor(
    private store$: Store<fromRoot.State>,
    private redirectionService: RedirectionService,
    @Inject(PLATFORM_ID) private platformId: object
  ) { }

  canActivate(): Observable<boolean> {
    if (isPlatformServer(this.platformId)) {
      return of(true)
    }
    return this.store$.select(fromRoot.getIsAdministrator).pipe(concatMap((isAdmin) => {
      if (isAdmin) {
        return of(true);
      } else {
        this.redirectionService.redirectTo404();
        return of(false);
      }
    }));
  }
}

